/*
 * @author      IRIS Interactive
 * @date        28/07/2022 16:30
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import 'jquery' // eslint-disable-line
import LinkAnchorAction from './actions/single/link-anchor.action'
import CommentsService from './services/comments.service'
import CollapseService from './services/single/collapse.service'
import CrossSellingService from './services/single/cross-selling.service'
import MapFullscreenService from './services/single/map-fullscreen.service'
import TagsService from './services/single/tags.service'

document.addEventListener('DOMContentLoaded', () => {
    new TagsService()
    new CollapseService()
    new MapFullscreenService()
    new CommentsService()
    new LinkAnchorAction()
    new CrossSellingService()
})
